import React, { Component } from 'react';
import { connect } from 'react-redux';

import { search } from '~/actions/orders';
import Spinner from '~/components/Spinner';
import Order from './order';

import Styles from './order.scss';

class OrderSearchView extends Component {
  static contextTypes = {
    apiClient: React.PropTypes.object.isRequired
  };
  constructor(props) {
    super(props);
    this.seekInter = 0;
    this.state = { searchResults: [], loading: false };
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.query !== nextProps.query) {
      this.seek(nextProps.query);
    }
  }

  seek(query) {
    clearInterval(this.seekInter);
    this.seekInter = setTimeout(() => {
      this.setState({ loading: true });
      search(this.props.dispatch, this.context.apiClient, query)
        .then(response => {
          this.setState({ searchResults: response.data.docs.map(d => d.orderId), loading: false });
        })
        .catch(() => {
          this.setState({ loading: false });
        });
    }, 200);
  }

  render() {
    if (this.props.tabData.size === 0) {
      return <div />;
    }
    if (this.state.loading) {
      return <Spinner />;
    }
    const searchResults = this.props.tabData
      .toArray()
      .map(tab =>
        tab.get('orders').filter(o => this.state.searchResults.includes(o.get('orderId')))
      )
      .reduce((carry, tab) => carry.concat(tab))
      .toSet()
      .toJS();
    const orders = searchResults.map((item, index) => {
      return <Order item={item} key={`order_${item.orderId + index}`} />;
    });
    return (
      <div>
        {!this.state.loading &&
          orders.length > 0 && (
            <div className={Styles.searchResult}>
              <div className={Styles.orderTitle}>Search for `{this.props.query}`</div>
              {orders}
            </div>
          )}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  tabData: state.getIn(['orders', 'tabData'], {})
});

// Setting pure: false is required for react router to work
export default connect(mapStateToProps, null, null, { pure: false })(OrderSearchView);



// WEBPACK FOOTER //
// ./app/pages/Orders/orderSearchView.js